import { Box, Typography } from '@mui/material';
import Skeleton from '@mui/material/Skeleton';
import Iconify from '../Iconify';

const SiteListViewData = ({ site, columnWidth, handleSiteClick }) => {

  if (!site) {
    return (
      <Box className='table_row'>
        <Box className='tableBodyCell' sx={{ color: '#EA5E00', minWidth: columnWidth.name, position: 'sticky', left: 0, backgroundColor: 'white', zIndex: 1 }}><Skeleton variant="text" width="100%" /></Box>
        <Box sx={{ color: '#414040', minWidth: columnWidth.address }}><Skeleton variant="text" width="100%" /></Box>
        <Box sx={{ color: '#414040', minWidth: columnWidth.postal_code }}><Skeleton variant="text" width="100%" /></Box>
        <Box sx={{ color: '#414040', minWidth: columnWidth.city }}><Skeleton variant="text" width="100%" /></Box>
        <Box sx={{ color: '#414040', minWidth: columnWidth.region }}><Skeleton variant="text" width="100%" /></Box>
        <Box sx={{ color: '#414040', minWidth: columnWidth.phone_number }}><Skeleton variant="text" width="100%" /></Box>
        <Box sx={{ color: '#EA5E00', width: '50px' }}><Iconify icon={'ri:arrow-right-s-line'} /></Box>
      </Box>
    );
  }

  return (
    <Box className='table_row' onClick={() => handleSiteClick(site.id)}>
      <Box className='tableBodyCell' sx={{ color: '#EA5E00', minWidth: columnWidth.name, maxWidth: columnWidth.name, position: 'sticky', left: 0, backgroundColor: 'white', zIndex: 1 }}>
        <Typography className='tableBodyTypography'>{site?.name}</Typography>
      </Box>
      <Box className='tableBodyCell' sx={{ color: '#414040', minWidth: columnWidth.address, maxWidth: columnWidth.address }}>
        <Typography className='tableBodyTypography'>{site?.address || 'N/A'}</Typography>
      </Box>
      <Box className='tableBodyCell' sx={{ color: '#414040', minWidth: columnWidth.postal_code, maxWidth: columnWidth.postal_code }}>
        <Typography className='tableBodyTypography'>{site?.postal_code || 'N/A'}</Typography>
      </Box>
      <Box className='tableBodyCell' sx={{ color: '#414040', minWidth: columnWidth.city, maxWidth: columnWidth.city }}>
        <Typography className='tableBodyTypography'>{site?.city || 'N/A'}</Typography>
      </Box>
      <Box className='tableBodyCell' sx={{ color: '#414040', minWidth: columnWidth.phone_number, maxWidth: columnWidth.phone_number }}>
        <Typography className='tableBodyTypography'>{site?.phone_number || 'N/A'}</Typography>
      </Box>
      <Box className='tableBodyCell' sx={{ color: '#414040', minWidth: columnWidth.region, maxWidth: columnWidth.region }}>
        <Typography className='tableBodyTypography'>{site?.region.name}</Typography>
      </Box>
      <Box className='tableBodyCell' sx={{ color: '#EA5E00', minWidth: '50px' }}><Iconify icon={'ri:arrow-right-s-line'} /></Box>
    </Box>
  );
};

export default SiteListViewData;